// extracted by mini-css-extract-plugin
export default {"paginationWrapper":"PaginationControls-module__paginationWrapper___1rsEo","paginationButton":"PaginationControls-module__paginationButton___2BsbB"};